import { useEffect, useState } from "react";

type TickItem = { tone: "err" | "warn" | "ok" | "info"; text: string };

const seed: TickItem[] = [
  { tone: "err",  text: "● CVE-2025-31904 · CVSS 9.8 · RCE container orchestrator" },
  { tone: "warn", text: "▲ Phishing wave · banking vertical · ES/PT" },
  { tone: "ok",   text: "✓ All OSINT modules operational · latency < 800ms" },
  { tone: "info", text: "ℹ New writeup published · HTB · Active Directory" },
  { tone: "err",  text: "● CVE-2025-31817 · CVSS 8.7 · Linux kernel LPE" },
  { tone: "warn", text: "▲ Suspicious VPN exit nodes flagged · 12 ASNs" },
  { tone: "ok",   text: "✓ Knowledge base sync · 120+ articles indexed" },
  { tone: "info", text: "ℹ Global online operators · 143" },
  { tone: "err",  text: "● CVE-2025-31750 · CVSS 8.4 · SSO bypass" },
  { tone: "warn", text: "▲ Credential stuffing · 64 source ASNs" },
];

const toneClass: Record<TickItem["tone"], string> = {
  err: "text-[#ff5555]",
  warn: "text-[#ffaa44]",
  ok: "text-[#69f0ae]",
  info: "text-[#7dd3fc]",
};

export const GlobalTicker = () => {
  const [items, setItems] = useState<TickItem[]>(seed);

  // gentle reshuffle every 60s to feel alive without remounting
  useEffect(() => {
    const t = setInterval(() => {
      setItems((cur) => {
        const [first, ...rest] = cur;
        return [...rest, first];
      });
    }, 60000);
    return () => clearInterval(t);
  }, []);

  const doubled = [...items, ...items];

  return (
    <div className="hidden md:flex h-6 items-stretch border-b border-[hsl(var(--primary)/0.18)] bg-surface-1 overflow-hidden">
      <div className="flex items-center gap-1.5 px-3 bg-primary text-white font-mono text-[8.5px] font-semibold tracking-[0.18em] flex-shrink-0">
        <span className="text-[6px]">⬤</span> CVE LIVE
      </div>
      <div className="flex-1 overflow-hidden relative">
        <div className="intel-ticker-track-slow flex whitespace-nowrap font-mono text-[9px] tracking-[0.06em] py-1">
          {doubled.map((it, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-2 px-5 border-r border-border/60 text-muted-foreground"
            >
              <span className={toneClass[it.tone]}>{it.text}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
